<div
  class="align-items-center w-100 px-3 gap-4"
  [style.display]="(showTimeSlider$ | async) === true ? 'flex' : 'none'"
  [style.height]="'5rem'"
>
  <ngx-slider
    #timeSlider
    class=""
    [manualRefresh]="manualRefresh"
    (userChangeEnd)="timeSliderChanged($event)"
    [value]="selectedDateRangeMin$ | async"
    [highValue]="selectedDateRangeMax$ | async"
    [options]="timeSliderOptions$ | async"
  ></ngx-slider>
  <div
    (click)="
      showCalendar = showCalendar === false; clickedInsideCalendar($event)
    "
  >
    <fa-icon [icon]="faCalendarDay"></fa-icon>
  </div>
  <nb-calendar-range
    *ngIf="showCalendar"
    (rangeChange)="calendarRangeChange($event)"
    (click)="clickedInsideCalendar($event)"
    [visibleDate]="selectedDateRangeMin$ | async"
    [range]="calendarRange$ | async"
  ></nb-calendar-range>
</div>
